<template>
  <div class="event-context">
    <div class="relevance-screening">
      <div class="title">
        <el-button
          type="text"
          icon="el-icon-remove-outline"
          size="medium"
          @click="decreaseValue"
        ></el-button>
      </div>
      <div class="slider">
        <el-slider
          v-model="rangeVal"
          :show-tooltip="false"
          :min="0"
          :max="1"
          :step="0.05"
          @change="rangeValChanged"
        >
        </el-slider>
      </div>
      <div class="range-val">
        <span>{{ rangeVal }}</span>
        <el-button
          type="text"
          icon="el-icon-circle-plus-outline"
          size="medium"
          @click="valueAdded"
        ></el-button>
      </div>
    </div>

    <div class="timeline" v-if="aiResultData.length > 0">
      <div
        class="event-timeline"
        v-for="(item, index) in sortedCommunityData"
        :key="index"
        placement="top"
      >
        <div v-if="item.vectorScore > rangeVal">
          <!-- 时间日期 -->
          <div class="timeline-date" v-if="shouldDisplayItem(index)">
            <!-- <span><i class="el-icon-date"></i>{{ item.eventDate }}</span> -->
            <span><i class="el-icon-date"></i>{{ item.group.date }}</span>
          </div>
          <!-- 社区内容 -->
          <div class="timeline-card">
            <h4>
              {{ item.group.title }}
            </h4>
            <span class="vector-score"
              >相关度：{{ item.vectorScore.toFixed(3) }}</span
            >
            <span class="summary">
              {{ item.group.summary }}
            </span>
            <div class="related-articles">
              <h5>相关文章</h5>
              <ul>
                <li
                  v-for="(chileItem, idx) in item.eventIds"
                  :key="idx"
                  @click="openDetail(chileItem)"
                >
                  <div>
                    {{ chileItem.title }}
                  </div>
                  <div>发布日期：{{ chileItem.date.slice(0, 10) || "" }}</div>
                </li>
              </ul>
            </div>

            <el-collapse
              class="event-collapse"
              v-model="activeNames"
              @change="viewGraph(item, index)"
            >
              <el-collapse-item
                class="event-collapse-item"
                :id="item.eventIds[0].id"
                :title="activeNames.includes(index) ? '收起图谱' : '查看图谱'"
                :name="index"
              >
                <div class="radar-chart">
                  <div class="radar-chart-title">图谱分析</div>
                  <echarts-graph ref="graphs" :graphData="item"></echarts-graph>

                  <div class="graph-title" v-if="filteredNodes(item.nodes).length > 0">
                    <h4>相关实体</h4>
                    <el-table
                      :data="filteredNodes(item.nodes)"
                      align="center"
                      stripe
                      :header-cell-style="{
                        'text-align': 'center',
                        background: 'var(--brand)',
                        color: '#fff'
                      }"
                    >
                     <!--  <el-table-column
                        prop="type"
                        label="实体类型"
                        width="100"
                        align="center"
                      >
                        <template slot-scope="scope">
                          {{
                            scope.row.type === "PERSON"
                              ? "人物"
                              : scope.row.type === "GEO"
                              ? "地域"
                              : scope.row.type === "EVENT"
                              ? "事件"
                              : scope.row.type === "ORGANIZATION"
                              ? "组织"
                              : scope.row.type === "TIME"
                              ? "时间"
                              : scope.row.type === "CONCEPT"
                              ? "概念"
                              : scope.row.type === "TECHNOLOGY"
                              ? "技术"
                              : scope.row.type === "LOCATION"
                              ? "位置"
                              : scope.row.type === "EVENT TIME"
                              ? "事件时间"
                              : scope.row.type
                          }}
                        </template> 
                      </el-table-column> -->
                      <el-table-column
                        prop="id"
                        label="事件时间"
                        width="160"
                        align="center"
                      >
                      </el-table-column>

                      <el-table-column prop="description" label="事件描述">
                      </el-table-column>
                    </el-table>
                  </div>

                  <div class="graph-title">
                    <h4>关系展示</h4>
                    <el-table
                      :data="item.links"
                      align="center"
                      stripe
                      :header-cell-style="{
                        'text-align': 'center',
                        background: 'var(--brand)',
                        color: '#fff'
                      }"
                    >
                      <el-table-column
                        prop="source"
                        label="实体A"
                        width="100"
                        align="center"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="target"
                        label="实体B"
                        width="160"
                        align="center"
                      >
                      </el-table-column>
                      <el-table-column prop="description" label="关系描述">
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>

    <div v-if="vectorScoreMax > rangeVal"></div>
    <div v-else>
      <el-empty description="调整相关度数值，查看更多脉络"></el-empty>
    </div>
    <!-- <div class="no-data" v-else>
      <el-empty
        description="
      暂时没有相关内容，可以先看看其他的哦"
      ></el-empty>
    </div> -->
    <el-dialog
      :visible.sync="dialogVisible"
      title=""
      width="45%"
      @close="handleClose"
      :append-to-body="true"
      top="6vh"
    >
      <article-detail :articleDetail="articleDetail"></article-detail>
    </el-dialog>
  </div>
</template>

<script>
import eventBus from "@/pages/EventBus.js";

import EchartsGraph from "@/pages/views/project/components/EchartsGraph.vue";
import { GetSingleArticleAnalyse, GetJfrbArticle } from "@/api/index.js";
import ArticleDetail from "@/pages/views/project/components/ArticleDetail.vue";

export default {
  components: {
    EchartsGraph,
    ArticleDetail
  },
  props: {
    aiResultData: {
      type: Array
    },
    communityData: {
      type: Array
    }
  },
  data() {
    return {
      // loading: false,
      activeNames: [],
      graphObj: {
        keywords: [
          {
            field: "",
            word: "杭州西湖",
            andOrNot: 0
          }
        ],
        date: {
          from: "2024-04-09",
          to: "2024-05-09"
        }
      },
      newMergedData: [],
      dialogVisible: false,
      articleDetail: {},

      // rangeDefaultVal: 0.5, // 默认值
      rangeVal: 0.5, // 初始值可以设为 0 或其他介于 0 和 1 之间的值
      marks: {
        0: "0",
        0.1: "0.1",
        0.2: "0.2",
        0.3: "0.3",
        0.4: "0.4",
        0.5: "0.5",
        0.6: "0.6",
        0.7: "0.7",
        0.8: "0.8",
        0.9: "0.9",
        1: "1"
      },

      vectorScoreMax: 0
    };
  },
  mounted() {
    // this.cleanData();
    this.GetMax();
  },
  watch: {},
  computed: {
    // communityData 反序
    sortedCommunityData() {
      // return this.communityData.reverse();

      // this.communityData遍历，把vectorScore 大于 rangeVal筛选出来
      const filteredData = this.communityData.filter(
        (item) => item.vectorScore > this.rangeVal
      );

      filteredData.forEach((item) => {
        const nodesMap = new Map(item.nodes.map((node) => [node.id, node]));

        item.links.forEach((link) => {
          if (nodesMap.has(link.source)) {
            link.color = nodesMap.get(link.source).color;
          }
        });
      });

      return filteredData.sort((a, b) => {
        // 定义一个默认的较大时间戳，用于表示“时间未确认”的条目
        const defaultTimestamp = new Date(1900, 11, 31).getTime(); // 假设用一个未来的日期

        const dateA =
          a.group.date === "时间未确认"
            ? defaultTimestamp
            : new Date(a.group.date.replace(/年|月/g, "-").replace(/日/g, ""));
        const dateB =
          b.group.date === "时间未确认"
            ? defaultTimestamp
            : new Date(b.group.date.replace(/年|月/g, "-").replace(/日/g, ""));

        return dateB - dateA;
      });
    }
  },
  // inject: ["vectorScore"],

  methods: {
    // 相关实体-筛选数据 item.nodes
    filteredNodes(nodes) {
      return nodes.filter((node) => node.type === "EVENT TIME");
    },
    /**
     * 合并重复的日期
     */
    shouldDisplayItem(index) {
      if (index === 0) {
        // 第一个元素总是显示
        return true;
      }

      const currentEventDate = this.sortedCommunityData[index].group.date;
      const previousEventDate = this.sortedCommunityData[index - 1].group.date;
      return currentEventDate !== previousEventDate;
    },
    /**
     * 获取社区相关度最大值
     */
    GetMax() {
      this.communityData.forEach((item) => {
        this.vectorScoreMax = Math.max(this.vectorScoreMax, item.vectorScore);
      });
    },
    /**
     * 把获取到的脉络数据，合并处理加入时间排序去重等
     */
    cleanData() {
      const mergedData = [];

      this.communityData.forEach((item) => {
        item.eventIds.forEach((eventId) => {
          const match = this.aiResultData.find((e) => e.id === eventId.id);
          if (match) {
            const newItem = {
              ...item,
              // ...eventId,
              // ...match,
              date: match.date,
              id: match.id
            };
            mergedData.push(newItem);
          }
        });
      });

      // console.log(mergedData);
      this.newMergedData = mergedData;

      this.newMergedData.sort((a, b) => {
        const dateA = new Date(
          a.date.replace(/年|月/g, "-").replace(/日/g, "")
        );
        const dateB = new Date(
          b.date.replace(/年|月/g, "-").replace(/日/g, "")
        );
        return dateB - dateA; // 升序排序，若需要降序则返回 dateB - dateA
      });
    },

    /**
     * 相关值变化，重新获取信息图谱
     */
    rangeValChanged(val) {
      eventBus.$emit("againGetGraph", val);
    },

    setTime(data) {
      let time = data.split("T");
      return time[0];
    },
    open(item) {
      window.open(item.url, "_blank");
    },

    openDetail(item) {
      this.articleDetail = [];
      this.dialogVisible = true;

      GetJfrbArticle({ id: item.id })
        .then((res) => {
          if (res.succeed) {
            this.articleDetail = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClose() {
      this.dialogVisible = false;
    },

    /**
     * @param 查看关系图谱
     */
    viewGraph(item, index) {
      // this.loading = false;
      // this.$refs.graphs.generateGraph()
      // console.log(item);
    },
    // 减少值
    decreaseValue() {
      this.rangeVal -= 0.05;
      this.rangeVal = Number(this.rangeVal.toFixed(2)); // 保留两位小数
      eventBus.$emit("againGetGraph", this.rangeVal);
    },
    // 增加值
    valueAdded() {
      this.rangeVal += 0.05;
      this.rangeVal = Number(this.rangeVal.toFixed(2)); // 保留两位小数
      eventBus.$emit("againGetGraph", this.rangeVal);
    }
  }
};
</script>

<style lang="scss" scoped>
.event-timeline {
  ::v-deep .el-timeline-item__tail {
    border: 1px dashed var(--brand);
  }
  ::v-deep .el-timeline-item__node {
    background-color: rgba(62, 157, 211, 1);
  }
  ::v-deep .el-timeline-item__wrapper {
    .el-timeline-item__timestamp {
      width: 110px;
      height: 32px;
      line-height: 22px;
      background: var(--brand);
      border-radius: 6px;
      color: #fff;
      text-align: center;
      overflow: hidden;
    }
  }
}

.radar-chart-title {
  background: url("../../../assets/jfrb/arrow.png") no-repeat left;
  font-weight: 600;
  font-size: 16px;
  color: var(--brand);
  padding-left: 24px;
}
.radar-chart-content {
}
.original {
  display: inline-block;
  vertical-align: text-bottom;
  color: #fff;
  font-size: 12px;
  margin-right: 5px;
  margin-left: 2px;
  background: #c0c0c0;
  border-radius: 50%;
  cursor: pointer;
  // margin-left: 5px;
  min-width: 18px;
  min-height: 18px;
  line-height: 16px;
  text-align: center;
  margin-bottom: 4px;
  // cursor: pointer;
  // margin-left: 10px;
  // padding-left:19px ;
  // background: url("../../../assets/jfrb/source.png")no-repeat 1px 1px;
  // font-size: 12px;
  // color: rgba(0, 0, 0, 0.6);
}
.no-data {
  text-align: center;
  margin: 60px 0 120px;
}
.related-articles {
  // border-top:1px solid #ededed;
  margin-top: 15px;
  h5 {
    font-size: 14px;
    font-weight: bold;
    color: var(--text-1);
    margin-top: 35px;
    margin-bottom: 5px;
  }
  ul {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    li {
      font-size: 14px;
      cursor: pointer;
      position: relative;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 2px 0;
      div:first-child {
        width: 500px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--brand);
        &::before {
          content: "•";
          padding-right: 4px;
        }
        &:hover {
          color: var(--text-link);
        }
      }
      div:last-child {
        width: 180px;
        font-size: 12px;
        color: var(--text-4);
      }

      // 奇偶行
      // &:nth-child(odd) {
      //   background: #f7f7f7;
      // }
      // &:nth-child(even) {
      //   background: #fff;
      // }
    }
  }
}
.related-community {
  margin-top: 25px;
  h5 {
    font-size: 14px;
    font-weight: bold;
    color: var(--text-2);
    margin-top: 15px;
    margin-bottom: 5px;
  }
  ul {
    margin-top: -5px;
    li {
      font-size: 14px;
      position: relative;
      margin-bottom: 5px;
      h5 {
        font-weight: normal;
        color: var(--brand);
        cursor: pointer;
        &:hover {
          color: var(--text-link);
        }
        &::before {
          content: "•";
          padding-right: 4px;
        }
      }
    }
  }
}
.event-context {
  position: relative;
  margin-top: 20px;
}
.relevance-screening {
  position: absolute;
  background-color: #f7f7f7;
  width: 260px;
  border-radius: 20px;
  text-align: center;
  top: -78px;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .title {
    color: var(--text-2);
    padding-left: 20px;
  }
  .slider {
    width: 135px;
    margin-left: 10px;
  }
  .range-val {
    color: var(--text-2);
    padding-left: 5px;
    span {
      width: 45px;
      display: inline-block;
      padding-right: 5px;
      text-align: center;
    }
  }
}
::v-deep
  .event-timeline
  .el-timeline-item__wrapper
  .el-timeline-item__timestamp {
  width: 174px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 24px;
  &::before {
    content: "\e78e";
    font-family: element-icons !important;
    color: #fff;
    font-size: 15px;
    font-weight: normal;
    margin-left: 2px;
  }
}

.timeline {
  padding-left: 30px;
  border-left: 1px dashed #d8d8d8;
  margin-left: 10px;
}
.timeline-date {
  color: #fff;
  background-color: var(--brand);
  width: 172px;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  padding: 4px 10px;
  border-radius: 24px;
  margin-bottom: 10px;
  position: relative;
  i {
    margin-right: 5px;
  }
  &::before {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 10px;
    display: block;
    background-color: var(--brand);
    position: absolute;
    left: -35px;
    top: 10px;
    box-shadow: 0 0 0 8px rgba(62, 157, 211, 0.15);
  }
}
.timeline-card {
  border: 1px solid #ededed;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.05);
  margin-bottom: 40px;
  padding: 20px;
  position: relative;
  h4 {
    font-weight: 600;
    font-size: 20px;
    color: #222222;
    margin-bottom: 5px;
    cursor: pointer;
  }
  .vector-score {
    font-size: 12px;
    color: #ed9a00;
    position: absolute;
    right: 1px;
    top: 0;
    padding: 4px 10px;
    background-color: #fffbf0;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .event-collapse {
    border: none;
    .event-collapse-item {
      .el-collapse-item__wrap {
        border-bottom: none;
      }
    }
  }
}

::v-deep .el-collapse-item__header {
  color: var(--brand);
  display: block;
  text-align: right;
  border-top: none;
  border-bottom: none !important;
}
::v-deep .el-collapse-item__header::before {
  content: "";
  display: inline-block;
  width: 87%;
  height: 1px;
  background: #ebeef5;
  margin-right: 20px;
  margin-bottom: 4px;
}

.graph-title {
  margin-bottom: 30px;
  h4 {
    color: var(--text-1);
    margin-bottom: 15px;
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    font-weight: bold;
    &::before {
      content: "";
      width: 3px;
      height: 16px;
      background-color: var(--text-2);
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }
}
::v-deep .el-collapse-item__wrap {
  border-bottom: none;
}
</style>
